import React, { Component } from 'react';
import ChartsWrapper from '../chartsWrapper/ChartsWrapper.js';
import Map from '../map/Map.js';
import './DataPanel.scss';

function closest(num, arr, prop) {
	const result = arr.reduce((prev, curr) => 
		(Math.abs(curr[prop] - num) < Math.abs(prev[prop] - num) ? curr : prev)
	);
	return arr.findIndex(a => a[prop] === result[prop]);
}

class DataPanel extends Component {
	routePoints = this.props.tripGps.map(data => [data.lon, data.lat]);
	accelerationData = this.getDataForCharts('acceleration');
	steeringData = this.getDataForCharts('steering');
	dataFrameRate = this.getDataFrameRate();
	getDataForCharts(dataset) {
		return this.props.data.map(a => {
			return {
				timestamp: a.timestamp,
				...a[dataset]
			}
		});
	}
	getDataFrameRate() {
		let accumulator = 0;
		let frameRate;
		for (frameRate = 1; accumulator < 1000; frameRate++) {
			accumulator += this.props.data[frameRate].timestamp - this.props.data[frameRate - 1].timestamp
		}
		return frameRate;
	}
	render() {
		const currentDataIndex = closest(
			this.props.data[0].timestamp + (this.props.currentPlaybackTime * 1000),
			this.props.data,
			'timestamp'
		);
		return (
			<div className="dataPanelContent layout-row">
				<Map
					currentlyPlaying={this.props.currentlyPlaying}
					currentPlaybackTime={this.props.currentPlaybackTime}
					data={this.props.data[currentDataIndex].gps}
					speed={this.props.data[currentDataIndex].speed}
					routePoints={this.routePoints}
				/>
				<ChartsWrapper
					title="ACCELERATION"
					frameRate={this.dataFrameRate}
					currentDataIndex={currentDataIndex}
					data={this.accelerationData}
					lineColor="#e024f2"
					videoReady={this.props.videoReady}
				/>
				<ChartsWrapper
					title="STEERING"
					frameRate={this.dataFrameRate}
					currentDataIndex={currentDataIndex}
					data={this.steeringData}
					lineColor="#f2eb24"
					videoReady={this.props.videoReady}
				/>
			</div>
		);
	}
}

export default DataPanel;
